const accountingSoftware = ["Quickbooks", "Xero", "Sage Accounting"];

export default accountingSoftware;
